import './App.css';
import GriffBish from './assets/griffBish';
import { getBirthdayCountdown, getNewYearsCountdown, getChristmasCountdown } from './dateHelpers';
import { useEffect, useState } from 'react';

const App = () => {

  const [birthdayCountdown, setBirthdayCountdown] = useState({});
  const [newYearsCountdown, setNewYearsCountdown] = useState({});
  const [christmasCountdown, setChristmasCountdown] = useState({});

  useEffect(() => {
    setInterval(() => {
      setBirthdayCountdown(getBirthdayCountdown());
      setNewYearsCountdown(getNewYearsCountdown());
      setChristmasCountdown(getChristmasCountdown());
    }, 1000);
  }, [setBirthdayCountdown])

  return (
    <div className="App">
      <header className="App-header">
        <GriffBish/>
        <p>
            Countdown to Christmas: 
            <p>
              {christmasCountdown.days >= 364 ? (
                <b> 0 DAYS 🥳 </b>
              ) 
              : (
                <b>{christmasCountdown.days} days {christmasCountdown.hours}:{christmasCountdown.minutes}:{christmasCountdown.seconds}</b>
              )}
            </p>
        </p>
        <p>
            Countdown to New Year's Day: 
            <p>
              {newYearsCountdown.days >= 364 ? (
                <b> 0 DAYS 🥳 </b>
              ) : (
                <b>{newYearsCountdown.days} days {newYearsCountdown.hours}:{newYearsCountdown.minutes}:{newYearsCountdown.seconds}</b>
              )}
            </p>
        </p>
        <p>
            Countdown to my birthday: 
            <p>
              {birthdayCountdown.days >= 364 ? (
                <b> 0 DAYS 🥳 </b>
              ) : (
                <b>{birthdayCountdown.days} days {birthdayCountdown.hours}:{birthdayCountdown.minutes}:{birthdayCountdown.seconds}</b>
              )}
            </p>
        </p>
      </header>
    </div>
  );
}

export default App;
